"use strict";

exports.__esModule = true;
exports.EditableIFrameElement = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Device = require("../../Device");
var _Theme = require("../../Theme");
var _Time = require("../../Time");
var _common = require("../common");
var _dec, _dec2, _class;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var IFrameContainer = _styledComponents["default"].div.withConfig({
  displayName: "EditableIFrameElement__IFrameContainer",
  componentId: "sc-613ywf-0"
})(["position:absolute;left:0;right:0;top:0;bottom:0;border:solid 1px ", ";"], (0, _Theme.val)("borderColor"));

/**
 * Displays a label for a section.
 */
var EditableIFrameElement = exports.EditableIFrameElement = (_dec = _Device.DeviceContext.withContext, _dec2 = _Time.ReportingPeriodContext.withContext, _dec(_class = _dec2(_class = /*#__PURE__*/function (_Component) {
  function EditableIFrameElement() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(EditableIFrameElement, _Component);
  var _proto = EditableIFrameElement.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      device = _this$props.device,
      reportingPeriod = _this$props.reportingPeriod,
      _this$props$urlTempla = _this$props.urlTemplate,
      urlTemplate = _this$props$urlTempla === void 0 ? "about:blank" : _this$props$urlTempla;
    var url = urlTemplate;
    if (device != null) {
      url = url.replace(/\{device_id\}/g, device.uuid);
      url = url.replace(/\{device_name\}/g, device.name);
    }
    if (reportingPeriod != null) {
      url = url.replace(/\{start_date\}/g, new Date(reportingPeriod.interval.startMillis).toISOString());
      url = url.replace(/\{end_date\}/g, new Date(reportingPeriod.interval.endMillis).toISOString());
    }
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        position: "relative"
      }
    }, /*#__PURE__*/_react["default"].createElement("iframe", {
      title: "IFrameElement",
      style: Object.assign({
        border: "none"
      }, (0, _common.getWidgetPositionProps)(this.props)),
      src: url
    }), /*#__PURE__*/_react["default"].createElement(IFrameContainer, (0, _common.getWidgetInteractionProps)(this.props)));
  };
  return EditableIFrameElement;
}(_react.Component)) || _class) || _class);